import Cookies from "js-cookie";
import { isLocal } from "./RegionHelper";

export const getCookie = (name: string) => {
  return Cookies.get(name);
};

export const getCookieBoolean = (name: string): boolean => {
  return Cookies.get(name) === "true";
};

// to remove the https:// from the url
const removeProtocol = (url: string) => {
  return url.replace(/^https?:\/\//, '')
}

const domain = removeProtocol(process.env.REACT_APP_PING_REDIRECT_URL ?? '.genpt.com')

//calculation of expiry time for cookie for expires_in it is 2 hours and all others 8 hours
const expiryTime = (name: string) => {
  const time: number = name === 'expires_in' ? 2 : 8
  const now = new Date()
  return new Date(now.getTime() + time * 60 * 60 * 1000)
}

export const setCookie = (name: string, value: string) => {
  Cookies.set(name, value, {
    sameSite: "None",
    secure: true,
    expires: expiryTime(name),
    ...(!isLocal && {domain: domain})
  });
};

export const removeCookie = (name: string) => {
  Cookies.remove(name, {
    sameSite: "None",
    secure: true,
    expires: expiryTime(name),
    ...(!isLocal && {domain: domain})
  });
};

// added buffer time to call the token before 5 minutes
export const bufferTime = 300;

export const calculateExpireTime = (time: string): number => {
  return (Number(time) - bufferTime) * 1000;
};

// Unix time stamp to mili second conversion both for seconds (10 chars) and mili seconds(13 chars)
export const unixToMiliSec = (time: number): number => {
  const length = time.toString().length
  const timeParam = length === 10 ? time * 1000 : time
  const currentTime = Math.floor(Date.now())
  return timeParam - currentTime
}

// Second to unix time stamp conversion
export const secondToUnix = (time: string): string => {
  const currentTime = Math.floor(Date.now() / 1000);
  return (Number(time) + currentTime).toString();
};

export const clearCustomCookies = () => {
  removeCookie('authenticated')
  removeCookie('isCOS')
  removeCookie('expires_in')
}
